import caching from "./reducer";

export default caching;
